import React from "react";

interface ProductStatusChipProps {
  title: string;
  isCertified?: boolean;
  showCertificationStatus?: boolean;
  className?: string;
}

const ProductStatusChip: React.FC<ProductStatusChipProps> = ({
  title,
  isCertified,
  showCertificationStatus = false,
  className = "admin-page__chip",
}) => {
  const hasCertificationStatus = typeof isCertified === "boolean";

  return (
    <span className={className}>
      <span className="admin-page__chip-content">
        <span>{title}</span>
        {showCertificationStatus && hasCertificationStatus && (
          <span
            className={`admin-page__chip-meta ${
              isCertified
                ? "admin-page__chip-meta--success"
                : "admin-page__chip-meta--muted"
            }`}
          >
            {isCertified ? "Jau sertifikuotas" : "Dar nesertifikuotas"}
          </span>
        )}
      </span>
    </span>
  );
};

export default ProductStatusChip;